var Export = /** @class */ (function () {
    function Export(element) {
        this.element = element;
        this.disable();
        this.initEvents();
        this.checkState();
    }
    Export.prototype.initEvents = function () {
        var _this = this;
        this.element.querySelectorAll('input[type=checkbox]').forEach(function (checkbox) {
            checkbox.addEventListener('change', function () { return _this.checkState(); });
        });
    };
    Export.prototype.disable = function () {
        this.element.querySelectorAll('button[data-export]').forEach(function (button) { return button.setAttribute('disabled', '1'); });
    };
    Export.prototype.enable = function () {
        this.element.querySelectorAll('button[data-export]').forEach(function (button) { return button.removeAttribute('disabled'); });
    };
    Export.prototype.checkState = function () {
        var checked = 0;
        this.element.querySelectorAll('input[name="list_screen_ids[]"]').forEach(function (el) {
            if (el.checked) {
                checked++;
            }
        });
        if (checked > 0) {
            this.enable();
        }
        else {
            this.disable();
        }
    };
    return Export;
}());
export default Export;
